function FormatoDataTempo (datetime) {
    let dataTempo = datetime.split(' ');
    let yMD = dataTempo[0].split('-');

    return `${yMD[2]}/${yMD[1]}/${yMD[0]} ${dataTempo[1]}`;
}

export const parseDate = (dateString) => {
    if (typeof dateString !== 'string') {
        return new Date(0); // Retorna uma data inválida
    }
    const parts = dateString.split('/');
    if (parts.length !== 3) {
        return new Date(0); // Retorna uma data inválida
    }
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
};

export default FormatoDataTempo;